import React from "react";
import { Comprehensive, Clarity, Knowledge, Idea, Network, Growth } from "../common/BrandShapes";

/**
 * VenturaZ — global backdrop.
 * Uses the brand's fluid green→teal→blue gradient as an ambient wash behind
 * every marketing page, then floats six brand-guideline shapes at low opacity.
 * Sits at z-index -10 so all content stays interactive.
 */
export default function BackgroundClouds() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 pointer-events-none overflow-hidden"
      data-testid="brand-backdrop"
    >
      {/* Base wash — soft brand tints (kept low opacity so light theme stays readable) */}
      <div className="absolute inset-0 venturaz-base-wash" />

      {/* Fluid blobs echoing the primary palette (forest green → cyan turquoise → blue-green) */}
      <div className="fluid-blob fluid-blob-green" style={{ top: "-14%", left: "-8%", width: "620px", height: "620px" }} />
      <div className="fluid-blob fluid-blob-teal" style={{ top: "12%", right: "-10%", width: "540px", height: "540px" }} />
      <div className="fluid-blob fluid-blob-aqua" style={{ top: "62%", left: "10%", width: "660px", height: "660px" }} />
      <div className="fluid-blob fluid-blob-gold" style={{ bottom: "-10%", right: "6%", width: "440px", height: "440px" }} />
      <div className="fluid-blob fluid-blob-teal" style={{ top: "170%", right: "-12%", width: "560px", height: "560px", opacity: 0.16 }} />
      <div className="fluid-blob fluid-blob-green" style={{ top: "240%", left: "-10%", width: "620px", height: "620px", opacity: 0.14 }} />

      {/* VenturaZ brand-guideline shapes — subtle outline motifs scattered as decoration.
          Colored in Blue-Green (#1795BD) to match brand primary. */}
      <Comprehensive size={200} color="#1795BD" opacity={0.14} strokeWidth={1.2}
        className="brand-shape absolute" style={{ top: "6%", right: "6%" }} />
      <Idea size={200} color="#088561" opacity={0.16} strokeWidth={1.2}
        className="brand-shape absolute" style={{ top: "38%", left: "3%" }} />
      <Growth size={240} color="#1795BD" opacity={0.12} strokeWidth={1.4}
        className="brand-shape absolute" style={{ top: "78%", right: "4%" }} />
      <Clarity size={180} color="#007453" opacity={0.13} strokeWidth={1.2}
        className="brand-shape absolute" style={{ top: "128%", left: "6%" }} />
      <Knowledge size={200} color="#B58900" opacity={0.13} strokeWidth={1.2}
        className="brand-shape absolute" style={{ top: "168%", right: "6%" }} />
      <Network size={200} color="#088561" opacity={0.12} strokeWidth={1.2}
        className="brand-shape absolute" style={{ top: "218%", left: "8%" }} />
    </div>
  );
}
